{
  "version": 1,
  "asset_id": "906207e2-eb14-44eb-a91e-ab7a4d4f2138",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/906207e2-eb14-44eb-a91e-ab7a4d4f2138/dilated-pouch-contrast-800.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/906207e2-eb14-44eb-a91e-ab7a4d4f2138/dilated-pouch-contrast-800.jpg",
  "original_filename": "dilated-pouch-contrast-800.jpg",
  "size": 64088,
  "content_type": "image/jpeg",
  "created_at": "2026-09-20T23:09:04Z"
}
